import { Link } from "react-router-dom";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { useSEO } from "@/lib/useSEO";
import { glossary } from "@/data/glossary";
import { BookOpen } from "lucide-react";

export default function Glossary() {
  useSEO({
    title: "Boxing Glossary — Techniques & Terms Explained | Better Through Boxing",
    description: "Learn boxing techniques and terms — jab, cross, hook, slip, footwork and more — explained simply by Coach Chris. Free technique guide for beginners.",
    path: "/boxing-glossary",
    keywords: ["boxing terms", "boxing techniques explained", "boxing glossary", "how to throw a jab", "boxing for beginners"],
  });

  const byCat = glossary.reduce((acc, g) => { (acc[g.category] = acc[g.category] || []).push(g); return acc; }, {});

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <SiteHeader />
      <section className="max-w-4xl mx-auto px-6 pt-16 pb-8">
        <p className="text-[11px] uppercase tracking-[0.3em] text-[#FF331F] font-bold">Learn</p>
        <h1 className="font-display text-4xl sm:text-5xl uppercase tracking-tight mt-3">Boxing Glossary</h1>
        <p className="text-zinc-400 text-base mt-4 max-w-2xl">Every punch, defense, and concept explained in plain English by Coach Chris. Tap any term to learn how to do it and the mistakes to avoid.</p>
      </section>

      <section className="max-w-4xl mx-auto px-6 pb-20 space-y-8">
        {Object.entries(byCat).map(([cat, terms]) => (
          <div key={cat}>
            <h2 className="font-display uppercase tracking-widest text-sm text-[#FF331F] mb-3">{cat}</h2>
            <div className="grid sm:grid-cols-2 gap-3">
              {terms.map((g) => (
                <Link key={g.slug} to={`/boxing-glossary/${g.slug}`} data-testid={`glossary-card-${g.slug}`}
                  className="group border border-[#27272A] bg-[#0F0F0F] p-4 hover:border-[#FF331F] transition-colors">
                  <div className="flex items-center gap-2">
                    <BookOpen className="h-4 w-4 text-[#FF331F]" />
                    <span className="font-semibold text-white">{g.term}</span>
                  </div>
                  <p className="text-xs text-zinc-500 mt-2 line-clamp-2">{g.short}</p>
                </Link>
              ))}
            </div>
          </div>
        ))}
      </section>
      <SiteFooter />
    </div>
  );
}
